import React from "react";

const Subscribe = () => {
  return <div className="subscribe">subscribe</div>;
};

export default Subscribe;
